import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export function generatePdf(cadastros, selectEquipe) {
  const titlePdf = 'Vacinas não enviadas'
  const titlePdfSave = utils.methods.titlePdf(titlePdf, selectEquipe.no_equipe)
  const descriptionPdf = 'Vacinas, possivelmente, não enviadas ao SISAB'
  const headersPdf = [
    'Vacina',
    'Dose',
    'Aplicação',
    'Atendimento',
    'Cidadão',
    'Mãe',
    'DOCUMENTO',
  ]

  const dataPdf = cadastros.map((item) => {
    const documentos = []
    if (item.nu_cpf) documentos.push(`CPF ${item.nu_cpf}`)
    if (item.nu_cns) documentos.push(`CNS ${item.nu_cns}`)

    return {
      no_imuno: item.no_imuno,
      no_dose_imuno: item.no_dose_imuno,
      dt_aplicacao: item.dt_aplicacao,
      dt_atendimento: item.dt_atendimento,
      no_cidadao: item.no_cidadao,
      no_mae: item.no_mae,
      documento: documentos.join('\n'),
    }
  })

  const table = utils.methods.createTablePdf(dataPdf)
  const doc = new jsPDF(utils.methods.encryptionPdf())

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64Brasao) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64Brasao,
        titlePdf,
        descriptionPdf
      )

      const equipeInfo = [
        { label: 'Equipe', value: selectEquipe.no_equipe },
        { label: 'CNES', value: selectEquipe.nu_cnes },
        { label: 'INE', value: selectEquipe.nu_ine },
      ]

      verticalPosition = utils.methods.bodyPdf(
        doc,
        equipeInfo,
        verticalPosition
      )

      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: ({ section }) => {
          if (section === 'head') doc.setTextColor(0, 0, 0)
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  Vacina: 'no_imuno',
  Dose: 'no_dose_imuno',
  Aplicação: 'dt_aplicacao',
  Atendimento: 'dt_atendimento',
  Nome: 'no_cidadao',
  Mãe: 'no_mae',
}
